import './style.scss'
import { useContext, useEffect, useState } from 'react';
import utility from 'src/utils/utility'
import { useNavigate } from 'react-router-dom';
import ApiContext from 'src/provider/API/call-service';
import SemiCircleProgressBar from "react-progressbar-semicircle";
import { AppLabel, AppSpan, AppText, Button, CustomContainer, FlexColumn, FlexRow, ScreenContainer } from 'src/style';
import { HiOutlineChevronDown } from 'react-icons/hi';
import {RiExternalLinkLine} from 'react-icons/ri'
import { CustomersCount, TicketResponseRateChart, StatisticsSummary, TicketChannels } from 'src/component';
import { ExportTypes } from 'src/popup';
import { GoNote } from 'react-icons/go';
import { MdDateRange } from 'react-icons/md';


const Overview: React.FC = () => {
    const {API} = useContext(ApiContext)
    const navigate = useNavigate()
    const [isExport, setIsExport] = useState(false)
    const [date, setDate] = useState('1999-00-00')
    const [userStatistics, setUserStatistics] = useState<any>(null)

    useEffect(() => {
        fetchUserStats()
    }, [])

    async function fetchUserStats (startDate = '', endDate = '') {
        const response = await API.getUserStats({startDate, endDate})
        if (response) setUserStatistics(response)
    }

    return (
        <>
            <ScreenContainer 
                leftPadding='2.5' rightPadding='2.5'
                topPadding='1.5' bottomPadding='1.5'
            >
                <FlexRow height='100' hUnit='%' alignItems='flex-start'>
                    <CustomContainer 
                        width='72' sizeUnit='%' height='100' hUnit='%'
                        rightPadding='1.5' overflow='auto'
                        className='cs-overview-count-container'
                    >
                        <FlexRow justifyContent='space-between'>
                            <AppText color='#000000' fontWeight='600'>All customers count</AppText>
                            <CustomContainer 
                                width='22.6' radius='0.4' borderColor='#E2E8F0' 
                                leftPadding='1' rightPadding='1' topMargin='2'
                                bgColor='#ffffff' leftMargin='1.5'
                            >
                                <FlexRow height='4' justifyContent='space-between'>
                                    <input 
                                        className='date-input-hack' id='date' 
                                        type='date' 
                                        onChange={(e) => setDate(e.target.value)} 
                                        autoComplete="off"
                                    />
                                    <MdDateRange style={{fontSize: '2rem', color: '#4C6FFF'}} />
                                    <AppLabel 
                                        textSize='1.2' color='#718096' leftPadding='1' 
                                        topPadding='0.7' htmlFor='date'
                                        // style={{width: '18rem'}}
                                    >
                                        {date}
                                    </AppLabel>
                                    <HiOutlineChevronDown style={{fontSize: '2rem', color: '#A0AEC0'}} />
                                </FlexRow>
                            </CustomContainer>
                        </FlexRow>
                        <CustomersCount data={userStatistics} />
                        <CustomContainer topMargin='3'>
                            <AppLabel color='#000000' fontWeight='600'>Ticket response rate</AppLabel>
                            <CustomContainer 
                                height='45' borderColor='#E2E8F0' radius='0.4'
                                padding='1'
                            >
                                <TicketResponseRateChart />
                            </CustomContainer>
                        </CustomContainer>
                        <StatisticsSummary/>
                    </CustomContainer>

                    <CustomContainer 
                        width='28' sizeUnit='%' height='100' 
                        hUnit='%' overflow='auto' leftPadding='1.5'
                        className='cs-overview-ticket-container'
                    >
                        <FlexRow justifyContent='space-between' topMargin='2'>
                            <AppText color='#000000' fontWeight='600'>My Tickets Count</AppText>
                            <Button 
                                width='9.9' borderColor='#4C6FFF' height='3.6'
                                hoverBgColor='#4C6FFF' hoverColor='#ffffff' titleSize='1.2'
                                bgColor='transparent' color='#4C6FFF' leftMargin='1.5'
                                onClick={() => setIsExport(true)}
                            >
                                <RiExternalLinkLine style={{fontSize: '1.4rem', marginRight: '0.5rem'}} /> Export
                            </Button>
                        </FlexRow>
                        <FlexRow gap='1' topMargin='3' wrap='wrap'>
                            <CustomContainer
                                width='48.3' sizeUnit='%' height='8.4' radius='0.4'
                                borderColor='#E2E8F0' topPadding='1' bottomPadding='1.5'
                                leftPadding='0.5' rightPadding='0.5'
                                className='ticket-count'
                            >
                                <FlexRow justifyContent='space-between' bottomMargin='1'>
                                    <AppText color='#718096' textSize='1' fontWeight='600'>TOTAL TICKETS</AppText>
                                    <GoNote style={{color: '#4C6FFF', fontSize: '1.6rem'}} />
                                </FlexRow>
                                <AppSpan textSize='2' color='#718096' fontWeight='600'>100</AppSpan>
                            </CustomContainer>
                            <CustomContainer
                                width='48.3' sizeUnit='%' height='8.4' radius='0.4'
                                borderColor='#E2E8F0' topPadding='1.5' bottomPadding='1.5'
                                leftPadding='0.5' rightPadding='0.5'
                                className='ticket-count'
                            >
                                <FlexRow justifyContent='space-between' bottomMargin='1'>
                                    <AppText color='#718096' textSize='1' fontWeight='600'>PENDING TICKETS</AppText>
                                    <GoNote style={{color: '#F7936F', fontSize: '1.6rem'}} />
                                </FlexRow>
                                <AppSpan textSize='2' color='#718096' fontWeight='600'>30</AppSpan>
                            </CustomContainer>
                            <CustomContainer
                                width='48.3' sizeUnit='%' height='8.4' radius='0.4'
                                borderColor='#E2E8F0' topPadding='1.5' bottomPadding='1.5'
                                leftPadding='0.5' rightPadding='0.5'
                                className='ticket-count'
                            >
                                <FlexRow justifyContent='space-between' bottomMargin='1'>
                                    <AppText color='#718096' textSize='1' fontWeight='600'>RESOLVED TICKETS</AppText>
                                    <GoNote style={{color: '#4AAE8C', fontSize: '1.6rem'}} />
                                </FlexRow>
                                <AppSpan textSize='2' color='#718096' fontWeight='600'>60</AppSpan>
                            </CustomContainer>
                            <CustomContainer
                                width='48.3' sizeUnit='%' height='8.4' radius='0.4'
                                borderColor='#E2E8F0' topPadding='1.5' bottomPadding='1.5'
                                leftPadding='0.5' rightPadding='0.5'
                                className='ticket-count'
                            >
                                <FlexRow justifyContent='space-between' bottomMargin='1'>
                                    <AppText color='#718096' textSize='1' fontWeight='600'>UNRESOLVED TICKETS</AppText>
                                    <GoNote style={{color: '#F16063', fontSize: '1.6rem'}} />
                                </FlexRow>
                                <AppSpan textSize='2' color='#718096' fontWeight='600'>10</AppSpan>
                            </CustomContainer>
                            <TicketChannels/>
                            <CustomContainer topMargin='3'>
                                <AppLabel color='#000000' fontWeight='600'>Agent’s overall rating</AppLabel>
                                <FlexColumn 
                                    minHeight='13.1' radius='0.4' borderColor='#E2E8F0'
                                >
                                    <CustomContainer className='bg-semi-circle'>
                                        <SemiCircleProgressBar 
                                            percentage={66} 
                                            showPercentValue 
                                            stroke='#FAB592'
                                            strokeWidth= {35}
                                            background='#CBD5E0'
                                            diameter={210}
                                        />
                                    </CustomContainer>
                                </FlexColumn>
                            </CustomContainer>
                        </FlexRow>
                    </CustomContainer>
                </FlexRow>
            </ScreenContainer>
            { isExport &&
                <ExportTypes
                    close={() => setIsExport(false)} 
                />
            }
        </>
    );
}

export default utility.routeData('overview', 'Customer Support Overview', <Overview/>)